
























































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import MainHeader from '@/components/MainHeader'
import TableComponent from '@/components/TableComponent'
import DocumentModal from '../DocumentModal'
//   import { FicationAdd, FicationEdit } from '@/api/advicenote'
import { FileTypeList, getByCusr, getselectAllVlaue } from '@/api/utils'
import { doAddSuperivisionEnforcement,getsupervisionEnforcementInfo,updateEnforcement,doFinishSuperivion } from '@/api/supervision'
 import SupervisionUpload from '../SupervisionUpload/SupervisionUpload.vue'
  import {getLocalItem} from '@/utils'
//   import Upload from '@/components/Uploader/index'
import store from '@/store'
import moment from 'moment'
import {getRrealFile} from '@/api/utils'
@Component({
  name: 'Examine',
  components: { MainHeader, TableComponent, DocumentModal,SupervisionUpload },
})
export default class EditSence extends Vue {
  $refs!: { table: HTMLFormElement; ruleForm: HTMLFormElement };
  // $refs!: { ruleForm: HTMLFormElement  }
  private form: any = '';
   private showUpload:boolean=false
   private finish:any = '请选择'
   private closeSuper:any = false
  private action: string = 'add';
  private showRtn: boolean = true;
  private showAddDoc: boolean = false;
  // private loading:any = false
  private showDCM: boolean = false;
  private person: any = [];
  private searchParams: any = {
    enterprise: undefined,
    EntErpriSe: undefined,
  };
  private docData: any = null;
  private headerArr = ['现场监察', '现场监察新增'];
  //   private somell:string = '菏泽玉皇化工'
  private actioning: string =
    process.env.VUE_APP_API_BASE_URL +
    '/front/supervision/v1/supervisionUploadFile/commonUpload';
  private loading: boolean = false;
  private visible: boolean = false;
  private recordId: string = '';
  private promas: any = {};
  private user: any = '';
  private regionList: any = [];
  private hint: boolean = false;
  private filelistType: any = '';
  //   private formData: any = {
  //     enterpriseCode: '',
  //     fileTypeList: [],
  //     lawEnforcer: [],
  //     status: 0,
  //   };
  private dataSource: any = [];
  private fileTypeId: any = '';
  private datalevel: any = [];
  private idauthentication: string = '';
  private uploadata: any = {};
  private fileList: any = []; //编辑的时候改变它
  private headers: any = {
    Authorization: Vue.ls.get('ACCESS_TOKEN'),
  };
  private images: any = {};
  private columns: any = [
    {
      title: '文件名称',
      dataIndex: 'documentName',
      key: 'documentName',
      customRender: (text: any, row: any, index: any) => {
        return text ? text : '-'
      },
    },
    {
      title: '下发时间',
      dataIndex: 'sendTime',
      key: 'sendTime',
      // customRender: (text: any, row: any, index: any) => {
      //   return text ? text : '-'
      // },
    },
      {
      title: '下发状态',
      dataIndex: 'sendStatus',
      key: 'sendStatus',
      customRender: (text: any, row: any, index: any) => {
        if(text===0){
          return '未下发'
        }
        if(text===1){
          return '已下发'
        }
        if(text===2){
          return '已接收'
        }
      },
    },
    {
      title: '接收状态',
      dataIndex: 'sendStatus',
      key: 'sendStatus',
      customRender: (text: any, row: any, index: any) => {
        if(text===0){
          return '未下发'
        }
        if(text===1){
          return '已下发'
        }
        if(text===2){
          return '已接收'
        }
      },
    },
    //  {
    //   title: '接收状态',
    //   dataIndex: 'documentIssueState',
    //   key: 'documentIssueState',
    //   customRender: (text: any, row: any, index: any) => {
    //     return text===2 ? '已下发' : '未下发'
    //   },
    // },
    {
      title: '上传时间',
      dataIndex: 'uploadTime',
      key: 'uploadTime',
      // customRender: (text: any, row: any, index: any) => {
      //   return text ? text : '-'
      // },
    },
     {
      title: '上传状态',
      dataIndex: 'uploadStatus',
      key: 'uploadStatus',
      customRender: (text: any, row: any, index: any) => {
        return text===1 ? '已上传' : '未上传'
      },
    },
    
    {
      title: '操作',
      key: 'action',
      scopedSlots: { customRender: 'action' },
    },
  ];
  // private data: any = [
  //   {
  //     documentName:'菏泽市节能监察文件',
  //     upLoadUserName:'李强'
  //   }
  // ];
 private Reload:boolean=false
    private handleOpen(state:number){
      // this.result= state
      this.Reload = true
      this.showUpload=true
    }
    closeUp(){
      this.Reload = false
      this.showUpload=false
    }
  disabledDate(current: any) {
    return current < moment().subtract(0, 'day') //今天之前的年月日不可选，不包括今天
  }
  /** 下拉绑定 */
  filterOption(input: any, option: any) {
    return (
      option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    )
  }
  private docID:any = '' // 文书id
  private  editIndex:any = null
  handleEdit(value:any) {
    // console.log(value)
    this.editIndex = value.index
    this.docData = value
    this.docID= value.documentId
    this.showDCM = true
    this.showAddDoc = true
  }
  handleFinishOk(){
    if(this.finish!=='2'&&this.finish!=='3'){
      this.$message.warning('请选择监察结果')
      return
    }
    doFinishSuperivion({id:this.infoid,status:this.finish}).then((res:any)=>{
      if(res&&res.status===0){
        this.$message.success('结束监察成功')
        this.handleReturn()
      } else {
        this.$message.error(res.message)
      }
    })
  }
  private supervisionPlanTime:any = ''
  onChangeTime(date:any,dateString:any){
    this.supervisionPlanTime = dateString
  }
  addDoc() {
    // if (this.tableData.length > 0) {
    //   this.$message.warning('当前记录只能添加一条文书')
    //   return
    // }
    this.showDCM = true
    this.showAddDoc = true
  }
 
  tablechange(parms:any){
    if(parms){
      this.tableData.forEach((v:any)=>{
      v.sendFlag = true
    })
    } else {
       this.tableData.forEach((v:any)=>{
      v.sendFlag = false
    })
    }
    // this.tableData.forEach((v:any)=>{
    //   v.sendFlag = !v.sendFlag
    // })
  }
   selectOption(parms:any){
     
    const index = this.tableData.findIndex((v:any)=>{
        return v.documentId === parms.documentId
      })
      this.tableData[index].sendFlag = !this.tableData[index].sendFlag
  }
  docCallBack(data: any) {
    // console.log(data)
    if(data.isEdit){
      // debugger
       this.$set(this.tableData,data.editIndex,data)
    } else {
   
      const index = this.tableData.findIndex((res:any)=>{
        return data.documentId === res.documentId
      })
      if(index!==-1){
        this.$message.warning('同一条文书不可重复添加')
        return
        // this.tableData[index] = data
      }
       const index2 = this.tableData.findIndex((res:any)=>{
        return data. documentName === res. documentName
      })
      if(index2!==-1){
        this.$message.warning('同一条文书不可重复添加')
        return
        // this.tableData[index] = data
      }
     
     
       this.tableData.push({
        documentName:data.documentName,
        documentContent:data.documentContent,
        enterpriseUploadFlag:data.enterpriseUploadFlag,
        sendFlag:false,
        documentId:data.documentId,
        sendStatus:0

      })
       this.tableData.forEach((res:any,index1:any)=>{
          res.editIndex = index1
       })
    }
    // this.docData = data
    // if (this.tableData.length > 0) {
    //   this.tableData = []
    // }
    // data.forEach((element:any )=> {
    // })
    // this.tableData.push(data)
     this.$refs.table.refresh(true)
   this.docData = {}
  }
  private reset:any =false
  handDeletDoc(value:any) {
      const index = this.tableData.findIndex((v:any)=>{
        return v.documentId === value.documentId
      })
    this.tableData.splice(index,1)
    // this.docData ={}
    this.reset = true
    // this.docData.isNews = 'isnew'
    this.$refs.table.refresh(true)
  }
  private pdfUrl:any = ''
  private isInfo:any = false
  docDetaile(value:any){
    if(value.uploadStatus===1){
        this.visible = true
         getRrealFile({url:value.documentUrl}).then((res :any) => {
         const {status,data} = res
         if(status === 0){
            this.pdfUrl = data
         }})
    } else {
       this.docData = value
    // this.docID= row.id
    this.isInfo = true
    this.showDCM = true
    this.showAddDoc = true
    }
  }
  closeDoc() {
    this.showDCM = false
    this.showAddDoc = false
    this.isInfo = false
    this.docData ={}
  }
  // 将已上传的文件id发送后端绑定
  issueAnotice(val: number) {
    if(val!==3&&val!==4){
    this.form.validateFields((err: any, value: any) => {
     
      if (this.tableData.length===0) {
        this.$message.warning('请添加一个文书')
        return false
      }
      if (!err) {
        this.loading = true
        const postData: any = {}
        postData.enterpriseId = value.enterpriseCustId.key
        postData.status = val
        postData.lawEnforcerUserList = value.lawEnforcerUserList&&value.lawEnforcerUserList.map(
          (item: any) => {
            return {lawEnforcerUserId:item.key} 
          }
        )
        postData.documentList = this.tableData

        if(this.action!=='update'){
        doAddSuperivisionEnforcement(postData).then((res: any) => {
          if (res && res.status=== 0) {
            if (val === 1) {
              this.$message.success('保存成功')
            } else {
              this.$message.success('保存并下发成功')
            }
            this.loading = false
            this.handleReturn()
          } else {
            this.$message.error(res.message)
             this.loading = false
          }
        })} else {
          // postData.documentInfo.documentId = this.docData.id
          postData.id = this.infoid
          updateEnforcement(postData).then((res:any)=>{
             if (res && res.status=== 0) {
            if (val === 1) {
              this.$message.success('编辑成功')
               this.loading = false
            } else {
              this.$message.success('保存并下发成功')
               this.loading = false
            }
            this.handleReturn()
          } else {
            this.$message.error(res.message)
             this.loading = false
          }
          })
        }
      }
    })
    } else if(val===3){
        this.handleOpen(1)
    }else if (val === 4){
      this.closeSuper = true
    }
    
  }
  handleFinishcancel(){
    this.closeSuper = false
    this.finish = '请选择'
  }
  handleChange(emint: any) {
    this.searchParams.enterprise = emint.key
    this.searchParams.EntErpriSe = emint
  }
  upLoding(data: any) {
    var _this = this
    const timeage = moment(new Date()).format('YYYY-MM-DD')
    // _this.formData.fileTypeList.forEach((element: any, index: number) => {
    //   if (element.fileTypeId == data.fileTypeId) {
    //     if (data.fileList.length > 0) {
    //       element.files = data.fileList
    //       _this.data[index].createTime = timeage
    //       _this.data[index].upLoadUserName = _this.user.realName
    //     } else {
    //       element.files = data.fileList
    //       _this.data[index].createTime = ''
    //       _this.data[index].upLoadUserName = ''
    //     }
    //   }
    // })
  }
  // 选择公司名称的改变事件
  handlecaleChange(value: any) {
    this.searchParams.enterprise = value
  }
  // cancel 取消
  handlecancel() {
    this.visible = false
    this.fileList = []
    this.datalevel = []
  }
  // OK确认
  handleOk() {
    this.fileList = []
    this.visible = false
  }
  // 返回按钮
  handleReturn() {
    this.$router.replace({ name: 'SceneSupervision' })
  }
  private tableData: any = [];
  private getList() {
    const that = this
    return new Promise(function (resolve: any, reject: any) {
      const data = {
        status: 0,
        data: that.tableData,
      }
      return resolve(data)
    })
  }

  // 获取列表或者获取列表和列表下的文件
  //   getList() {
  //   const data = {
  //   functionType:1,
  //   recordId:this.action!='add'?this.recordId: ''
  //   }
  //   FileTypeList(data).then(res => {
  //   this.data = res.data
  //   if (this.action != 'add') {
  //   this.data.forEach((element:any,indexe:number) => {
  //   this.formData.fileTypeList.push({
  //   fileTypeId:element.fileTypeId,
  //   files:element.files
  //   })
  //   })
  //   } else {
  //   this.data.forEach((element:any,indexe:number) => {
  //   this.formData.fileTypeList.push({
  //   fileTypeId:element.fileTypeId,
  //   files:element.files
  //   })
  //   })
  //   this.fileList = []
  //   }
  //   })
  //   }
  // 点击上传或者查看
  derlogin(row: any) {
    //   store.state.commonStore.fileTypeId = row.fileTypeId
    this.filelistType = row.fileType * 1
    // for (var item of this.formData.fileTypeList) {
    //   if (item.fileTypeId === row.fileTypeId) {
    //     item.files.forEach((element: any, index: number) => {
    //       element.type = element.fileName
    //         .substring(element.fileName.lastIndexOf('.'))
    //         .toLowerCase()
    //       element.uid = element.id
    //       element.name = element.fileName
    //       element.url = element.filePath
    //     })
    //     this.fileList = item.files
    //     this.images = item.files
    //     this.visible = true
    //     return
    //   }
    // }
  }
   private client:any =getLocalItem('client')
  mounted() {
     if(this.action === 'update'){
       this.headerArr = ['现场监察', '现场监察编辑']
      }
    getselectAllVlaue().then((res) => {
      this.person = res.data
      // if (this.status !='0') {
      //   var value:any
      //   value = this.$route.query.lawEnforcer
      //   for(var item of value) {
      //     this.person.forEach((element:any,index:number) => {
      //       if(item == element.userId) {
      //         this.formData.Ynforcer.push({
      //           key:item,
      //           label:element.realName
      //         })
      //       }
      //     })
      //   }
      // }
    })
      // if (this.action !== 'update') {
      //   this.form.setFieldsValue({
      //     'lawEnforcerUserList': [
      //       {
      //         key: this.client.id,
      //         label: this.client.realName,
      //       },
      //     ],
      //   })
      // }
  }
  private infoid:any = ''
  private infoData:any = {
    status:0
  }
  created() {
    this.form = this.$form.createForm(this)

    if(this.$route.query.id){
      this.action = 'update'
      this.infoid = this.$route.query.id

    getsupervisionEnforcementInfo(this.infoid).then((res: any) => {
       if (res && res.status === 0) {
        this.infoData = res.data
        this.$nextTick(() => {
          this.form.setFieldsValue({
            enterpriseCustId: {
              key: 1222,
              label: res.data.enterpriseName,
            },
            lawEnforcerUserList: res.data.lawEnforcerUserNames.map(
              (item: any) => {
                return {
                  key: item.lawEnforcerUserId,
                  label: item.lawEnforcerUserName,
                }
              }
            ),
          })
        })
        this.tableData = res.data.enforcementList
        this.tableData.forEach((v:any,index:any)=>{
          v.sendFlag = false
          v.documentId = v.id
          v.editIndex =index
        })
        this.getList()
        this.$refs.table.refresh(true)
      }
    })
    }
    
    // this.action = this.$route.query.type.toString()
    // if (this.action == 'add') {
    //   this.somell = ''
    // } else {
    //   this.recordId = this.$route.query.recordId.toString()
    //   this.somell = this.$route.query.somell.toString()
    //   let text = ''
    //   this.regionList.forEach((element: any, index: number) => {
    //     if (element.enterpriseCode == this.$route.query.enterpriseCode) {
    //       text = element.enterpriseName
    //     }
    //   })
    //   this.searchParams.enterprise =
    //     this.$route.query.enterpriseCode.toString()
    //   this.searchParams.EntErpriSe = {
    //     key: this.$route.query.enterpriseCode,
    //     label: text,
    //   }
    // }
    //   this.getList()
    // FileTypeList({functionType:1}).then(res => {
    //     this.data = res.data
    // })
    getByCusr().then((res) => {
      this.regionList = res.data
    })
  }
}
